import * as moment from "moment";
import {InvoiceCreatedEventDataApiDto, InvoiceEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InvoiceEvent, {InvoiceEventTypeEnum} from "./InvoiceEvent";

/**
 * Invoice created event model.
 */
export default class InvoiceCreatedEvent extends InvoiceEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {InvoiceEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 * @param {InvoiceCreatedEventData} data draft invoice created event data.
	 */
	constructor(public readonly id: string,
		public readonly type: InvoiceEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment,
		public readonly data: InvoiceCreatedEventData) {
		super(id, type, creator, creationDateTime);
	}

	public static fromJson(json: InvoiceEventApiDto): InvoiceCreatedEvent {
		const data = InvoiceCreatedEventData.fromJson(json.data as InvoiceCreatedEventDataApiDto);
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new InvoiceCreatedEvent(json.id, InvoiceEventTypeEnum.InvoiceCreated, creator,
			moment(json.creationDateTime), data);
	}

	getIcon() {
		return Icon.Status;
	}

	getActivityType(): string {
		return `INVOICE CREATED`;
	}

	getActivityMessage(): string {
		return `Invoice has been created`
	}
}

export class InvoiceCreatedEventData {
	constructor(public readonly jobId: string,
		public readonly quoteId: string,
		public readonly invoiceNo: string,
		public readonly customerId: string,
		public readonly totalAmount: number,
		public readonly referenceNumber: string) {}

	public static fromJson(json: InvoiceCreatedEventDataApiDto): InvoiceCreatedEventData {
		return new InvoiceCreatedEventData(json.jobId, json.quoteId, json.invoiceNo, json.customerId, json.totalAmount,
			json.referenceNumber);
	}
}
